var elemental = require("../elem/elem.js");

export function multilevel(menu) {
  var elems = document.querySelectorAll(menu);

  elems.forEach(function (elem, index) {
    elem.childNodes.forEach(function (child, index) {
      // Child = LI
      let childlink = child.childNodes[0];

      if (childlink.classList) {
        if (childlink.classList.contains("menu-item-has-children")) {
          if (
            childlink.classList.contains("current-menu-parent") ||
            childlink.classList.contains("current_page_item")
          ) {
            document
              .querySelector("body.page")
              .classList.add("belongs-dropdown");
          }
          // Add Dropdown
          childlink.appendChild(
            elemental.elem('<span class="dropdown"></span>')
          );

          // Add Click Functionality
          childlink.addEventListener("click", (e) => {
            if (window.screen.width < 992) {
              e.stopPropagation();
              e.preventDefault();
            }

            console.log("link has been clicked on");

            let menuStatus = childlink.classList.contains("menu-active");

            elem.childNodes.forEach(function (childx, index) {
              childx.childNodes[0].classList.remove("menu-active");
            });

            if (menuStatus) {
              elem.classList.remove("parent-menu-active");
              childlink.classList.remove("menu-active");
            } else {
              elem.classList.add("parent-menu-active");
              childlink.classList.add("menu-active");
            }
          });
        }

        childlink.addEventListener("click", (e) => {
          if (!childlink.classList.contains("menu-item-has-children")) {
            let menuStatus = childlink.classList.contains("reg-menu-active");

            elem.childNodes.forEach(function (childx, index) {
              childx.childNodes[0].classList.remove("reg-menu-active");
            });

            if (menuStatus) {
              elem.classList.remove("reg-parent-menu-active");
              childlink.classList.remove("reg-menu-active");
            } else {
              elem.classList.add("reg-parent-menu-active");
              childlink.classList.add("reg-menu-active");
            }
          }
        });
      }
    });
  });
}
